import { render } from "./BlockLoader.vue?vue&type=template&id=10c1b175&scoped=true"
import script from "./BlockLoader.vue?vue&type=script&lang=js"
export * from "./BlockLoader.vue?vue&type=script&lang=js"

import "./BlockLoader.vue?vue&type=style&index=0&id=10c1b175&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10c1b175"]])

export default __exports__